import service from '@/utils/server';

const modName='/finance/credit/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//导出文件方法
export const getExportData = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//导入
export const creditUpload = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'upload',
    method: 'post',
    data
  });
};


//模板下载
export const downLoadCreditTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'creditTemplate/' + data.templateName,
    method: 'post',
    data
  });
};

//查询详情
export const creditBankInfo = data => {
  return service({
    url: modName + 'creditEdit/' + data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/finance/credit/api/index.js